export enum TagsEnum {
  Label = "Label",
  SoftwareApplication = "SoftwareApplication",
  SkuVersion = "SkuVersion",
}

export enum TagsEnumCamelPlural {
  Label = "labels",
  SoftwareApplication = "softwareApplications",
  SkuVersion = "skuVersions",
}
